// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"160":"4440e0167a6673c0","325":"9a0de32275d500ca","374":"333be8acaf883ee9","444":"b2da62d8c39f25e5"}[chunkId] + ".js";
};